// SEQ=10124 P8-CK-H — Pioneering UX 오버레이
// 사양: SEQ-10119 §3-3 #7 + SEQ-10123 §1-2 #7
//   ── 무료 도로 1 edge 클릭 (도로 인접 면제 — 본인 보드 임의 위치)
//   ── 단, 다른 점유와 충돌 금지 (양끝 vertex 중 하나가 다른 점유 마을 도시면 도로 미인접 허용)
//
// 본 오버레이는 안내 배지 + 후보 개수 + 취소만 담당.
// 보드 highlight + 클릭은 Play.tsx + CatanBoard 의 ActionMode 분기로 처리.
export interface PioneeringRoadOverlayProps {
  /** 클라 사전 집계 후보 edge 집합 (OWNER NULL + 본인 점유 충돌 없는 위치) */
  candidateEdgeIds: number[]
  onCancel: () => void
}

export default function PioneeringRoadOverlay({
  candidateEdgeIds, onCancel,
}: PioneeringRoadOverlayProps) {
  return (
    <div style={overlay}>
      <div style={card}>
        <div style={title}>🛤️ 개척 (Pioneering)</div>
        <div style={body}>
          <div>도로 1개를 무료로 건설합니다 (도로 인접 면제).</div>
          <div style={hint}>후보 edge {candidateEdgeIds.length}개 (보드 highlight).</div>
          {candidateEdgeIds.length === 0 && (
            <div style={warn}>건설 가능한 위치가 없습니다. 취소하세요.</div>
          )}
        </div>
        <div style={footer}>
          <button onClick={onCancel} style={btnSec}>취소</button>
        </div>
      </div>
    </div>
  )
}

const overlay: React.CSSProperties = { position: 'fixed', top: 12, right: 12, zIndex: 950, pointerEvents: 'none' }
const card:    React.CSSProperties = { background: '#fff', border: '1px solid #888', borderRadius: 6, padding: 12, minWidth: 240, boxShadow: '0 2px 8px rgba(0,0,0,0.2)', pointerEvents: 'auto' }
const title:   React.CSSProperties = { fontWeight: 'bold', marginBottom: 6, fontSize: 14 }
const body:    React.CSSProperties = { fontSize: 12 }
const hint:    React.CSSProperties = { fontSize: 11, color: '#666', marginTop: 4 }
const warn:    React.CSSProperties = { fontSize: 11, color: '#c00', marginTop: 4 }
const footer:  React.CSSProperties = { marginTop: 8, textAlign: 'right' }
const btnSec:  React.CSSProperties = { padding: '4px 10px', background: '#eee', border: '1px solid #aaa', borderRadius: 3, cursor: 'pointer' }
